import React, { useEffect, useState } from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import axiosInstance from '../../axios.config';
import { CircularProgress, Typography } from '@mui/material';

export const CourseChartModal = ({ open, onClose, courseid }) => {
    const [chartData, setChartData] = useState(null);
    const [courseName, setCourseName] = useState('');

    useEffect(() => {
        const fetchCourseReport = async () => {
            if (!courseid) return
            try {
                const response = await axiosInstance.get(`/UserCourseStep/GetAllCoursesAssignedCompleted/${courseid}`);
                const data = response.data;

                setCourseName(data.courseName);

                setChartData([
                    { id: 'Completed', label: 'Completed', value: data.completedCount, color: '#4caf50' },
                    { id: 'InProgress', label: 'In Progress', value: data.inProgressCount, color: '#ff9800' },
                    { id: 'NotStarted', label: 'Not Started', value: data.notStartedCount, color: '#f44336' },
                ]);
            } catch (error) {
                console.error("Error fetching course report:", error);
            }
        };

        fetchCourseReport();
    }, [courseid]);

    if (!chartData) return <></>

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{courseName}</DialogTitle>
            <DialogContent>
                {chartData ? (
                    <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <PieChart
                            series={[
                                {
                                    data: chartData,
                                    innerRadius: 60,
                                    outerRadius: 80,
                                },
                            ]}
                            innerRadius={50}
                            outerRadius={100}
                            height={200}
                            valueFormat={(value) => `${value}`}
                            colors={chartData.map(item => item.color)}
                        />
                    </div>
                ) : (
                    <Typography variant="h6" align="center" sx={{ paddingTop: '25px' }}>
                        <CircularProgress />
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};
